import { Component, Vue, Prop } from 'vue-property-decorator';
import { MiDialogOptions } from '@/components/MiDialog/MiDialog.ts';

@Component<MiEditable>({ })
export default class MiEditable extends Vue {
  @Prop({ default: '' })
  protected text!: string;

  @Prop({ default: 'Failed to update' })
  protected titleUpdateFailed!: string;

  protected originalText = '';

  protected editedText = '';

  protected failedText = '';

  protected isLoading = false;

  protected isFocused = false;

  protected mounted(): void {
    this.originalText = this.text;
    this.editedText = this.text;
  }

  protected handleBlur(event: KeyboardEvent | FocusEvent): void {
    // check for escape
    if (
      event.type === 'keydown'
      && (event as KeyboardEvent).keyCode === 27
    ) {
      this.handleCancelEvent(event.target as HTMLSpanElement);
    } else {
      this.handleEndEdit(event.target as HTMLSpanElement);
    }
    this.isFocused = false;
    (event.target as HTMLElement).blur();
  }

  protected handleEndEdit(target: HTMLSpanElement): void {
    this.editedText = target.innerText;
    if (this.originalText === this.editedText) { return; }
    this.isLoading = true;
    const event: EditableUpdateEvent = {
      value: this.editedText,
      updateSuccessHandler: () => this.updateSuccess(),
      updateFailureHandler: () => this.updateFailed(target),
    };
    this.$emit('update', event);
  }

  protected handleCancelEvent(target: HTMLSpanElement): void {
    target.innerText = this.originalText;
  }

  protected updateSuccess(): void {
    this.isLoading = false;
    this.originalText = this.editedText;
  }

  protected updateFailed(target: HTMLSpanElement): void {
    this.isLoading = false;
    this.failedText = this.editedText;
    this.editedText = this.originalText;
    target.innerText = this.originalText;
    this.$store.dispatch('openDialog', this.updateFailedDialogOptions);
  }

  protected get updateFailedDialogOptions(): MiDialogOptions {
    return {
      text: `${this.titleUpdateFailed} with: "${this.failedText}"`,
      type: 'error',
      buttons: {
        confirm: {
          text: 'Close',
          action: () => {
            this.$store.dispatch('closeDialog');
          },
        },
      },
    };
  }
}

export interface EditableUpdateEvent {
  value: string;
  updateSuccessHandler: () => void;
  updateFailureHandler: () => void;
}
